import {
  fetchWithErrorHandling,
  parseJSONWithBetterErrors,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {useMutation} from '@github-ui/react-query'
import type {ReactionViewerGroup} from '@github-ui/reaction-viewer/ReactionGroupsUtils'
import {useIssueCommentsActions, usePullRequestBasePath} from '../stores/selectors'

export function useReactToIssueCommentMutation() {
  const basePath = usePullRequestBasePath()
  const {updateIssueComment} = useIssueCommentsActions()

  const onSuccessCallback = (
    data: {reactionGroups: ReactionViewerGroup[]},
    args: {commentId: string; reaction: string; viewerHasReacted: boolean},
  ) => {
    updateIssueComment({
      match: storedComment => storedComment.id === args.commentId,
      transform: oldComment => {
        if (oldComment) {
          return {...oldComment, reactionGroups: data.reactionGroups}
        }
      },
    })
  }

  return useReactToIssueCommentMutationWithCallback(basePath, onSuccessCallback)
}

export function useReactToIssueCommentMutationWithCallback(
  basePath: string,
  onSuccessCallback?: (
    data: {reactionGroups: ReactionViewerGroup[]},
    args: {commentId: string; reaction: string; viewerHasReacted: boolean},
  ) => void,
) {
  return useMutation({
    mutationFn: async ({
      commentId,
      reaction,
      viewerHasReacted,
    }: {
      commentId: string
      reaction: string
      viewerHasReacted: boolean
    }) => {
      const apiUrl = `${basePath}/page_data/${
        viewerHasReacted ? PageData.removeCommentReaction : PageData.addCommentReaction
      }`

      const response = await fetchWithErrorHandling(apiUrl, {
        method: 'POST',
        body: {
          reaction,
          issueCommentId: commentId,
        },
      })

      const json = await parseJSONWithBetterErrors(response)
      throwErrorsIfBadResponse(response, json)
      return json
    },
    onSuccess: onSuccessCallback,
  })
}
